import { render, staticRenderFns } from "./ContractsTable.vue?vue&type=template&id=bccff9c6&scoped=true&"
import script from "./ContractsTable.vue?vue&type=script&lang=js&"
export * from "./ContractsTable.vue?vue&type=script&lang=js&"
import style0 from "./ContractsTable.vue?vue&type=style&index=0&id=bccff9c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccff9c6",
  null
  
)

export default component.exports